import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { ControlWithoutLabel } from 'shared/components/fields/control/without-label';
import { MaterialDropdown, TimeFieldInput } from 'shared/components/fields';
import { WeekdaysToggles } from 'console/climatic/setting-tabs/circuit/weekdays-toggles';
import { useContext } from 'react';
import { Z3KSettingsEditor } from 'z3k-settings/provider/types';
export function SchedulePeriod(props) {
    const { period_number, mode_options, start_time, end_time, interval } = props;
    const { config, replace_config } = useContext(Z3KSettingsEditor);
    return (_jsxs(Box, { display: "flex", flexDirection: "column", rowGap: 1, width: "100%", children: [period_number != null && _jsx(Typography, { children: period_number }), _jsxs(Box, { display: "flex", flexDirection: "column", rowGap: 1, width: "100%", children: [_jsxs(Box, { display: "flex", gap: "1em", flexWrap: "wrap", children: [_jsxs(Box, { display: "flex", justifyContent: "space-between", flexBasis: "60%", children: [_jsx(ControlWithoutLabel, { validation_result: null, validation_warnings_result: null, value: start_time, onChange: (new_value) => {
                                            replace_config({
                                                ...config,
                                                time_intervals: config.time_intervals.map((item) => {
                                                    if (item.id === interval.id) {
                                                        return {
                                                            ...item,
                                                            sh: new_value.hour || 0,
                                                            sm: new_value.min || 0,
                                                        };
                                                    }
                                                    return item;
                                                }),
                                            });
                                        }, field: TimeFieldInput }), _jsx(Box, { display: "flex", alignItems: "center", mx: 2, children: "\u2014" }), _jsx(ControlWithoutLabel, { validation_result: null, validation_warnings_result: null, value: end_time, onChange: (new_value) => {
                                            replace_config({
                                                ...config,
                                                time_intervals: config.time_intervals.map((item) => {
                                                    if (item.id === interval.id) {
                                                        return {
                                                            ...item,
                                                            eh: new_value.hour || 0,
                                                            em: new_value.min || 0,
                                                        };
                                                    }
                                                    return item;
                                                }),
                                            });
                                        }, field: TimeFieldInput })] }), _jsx(Box, { display: "flex", flexGrow: "1", children: _jsx(MaterialDropdown, { fullWidth: true, options: mode_options, variant: "outlined", value: interval.temperature, onChange: (value) => {
                                        replace_config({
                                            ...config,
                                            time_intervals: config.time_intervals.map((item) => {
                                                if (item.id === interval.id) {
                                                    return {
                                                        ...item,
                                                        temperature: value,
                                                    };
                                                }
                                                return item;
                                            }),
                                        });
                                    } }) })] }), _jsx(WeekdaysToggles, { bitmap: interval.action_register, onChangeBitmap: (bitmap) => {
                            replace_config({
                                ...config,
                                time_intervals: config.time_intervals.map((item) => {
                                    if (item.id === interval.id) {
                                        return {
                                            ...item,
                                            action_register: bitmap,
                                        };
                                    }
                                    return item;
                                }),
                            });
                        } })] })] }));
}
